import { useSelector } from 'react-redux';
import {
  fetchPromo,
  selectLandingPromoByType,
  selectLandingPromosDataState,
} from '../../state';
import { memo, useEffect, useMemo } from 'react';
import { Box, Skeleton, Text } from '@bonanza-social/moonlight';
import RewardsLabel from './RewardsLabel/RewardsLabel';
import { useDispatch } from '@bonanza-social/toolkit/state';

function IntroPromoLabel() {
  const dispatch = useDispatch();
  const welcomePromo = useSelector(selectLandingPromoByType('Welcome'));
  const welcomePromoDataState = useSelector(selectLandingPromosDataState);

  useEffect(() => {
    if (welcomePromoDataState === 'idle') {
      dispatch(fetchPromo());
    }
  }, [dispatch, welcomePromoDataState]);

  if (welcomePromoDataState.match('idle|pending')) {
    return (
      <Box flexDirection="column" alignItems="center" gap="space-400">
        <Skeleton borderRadius="radius-400" width={280} height={200} />
      </Box>
    );
  }

  return (
    <Box alignItems="center">
      <Text
        variant="h4"
        locNS="auth"
        locKey="introScreenGetLabel"
        gradient="darkSurfaceAccent"
        marginBottom="space-100"
      ></Text>
      {welcomePromo?.rewards?.length ? (
        <RewardsLabel
          rewards={welcomePromo?.rewards}
          overlapOffset="-space-500"
        />
      ) : null}
    </Box>
  );
}
export default memo(IntroPromoLabel);
